module.exports = __webpack_public_path__ + "static/media/weibo.5ebfb4ad.svg";